import { SEARCH_USER, SEARCH_USER_END, SEARCH_USER_INIT } from "../constants/search-user";

export function searchUser(tel: string) {
  return {
    type: SEARCH_USER,
    api: true,
    payload: {
      method: "GET",
      url: "/users",
      params: { tel },
    },
    data: { tel },
  };
}

export function searchUserInit() {
  return {
    type: SEARCH_USER_INIT,
  };
}

export function searchUserEnd() {
  return {
    type: SEARCH_USER_END,
  };
}
